import React from 'react'
import './MobileCanvas.css'

export default function MobileCanvas({ children, className = '', screenClass = '' }) {
  return (
    <div className={`mobile-canvas-frame ${className}`}>
      <div className="mobile-canvas-notch"></div>
      <div className={`mobile-canvas-screen ${screenClass}`}>
        {children}
      </div>
    </div>
  )
}
